<div class="container">
  <div>
    <div class="select-form">
      <lib-construction-site-picker
        [conSites]="this.state.conSites$"
        [preselectedConSite]="null"
        [showAllEntry]="true"
        (selectedConSiteChanged)="conSiteChange($event)"
      ></lib-construction-site-picker>
    </div>
    <div class="select-form" style="margin-bottom: 0px">
      <lib-month-picker
        style="width: 100%"
        (selectedValueChanged)="monthChange($event)"
        (selectedYearChanged)="yearChange($event)"
        [showAllEntry]="true"
      ></lib-month-picker>
    </div>
    <ion-searchbar
      [placeholder]="'reports.search' | translate"
      show-clear-button="focus"
      (ionInput)="setSearchTerm($event)"
    ></ion-searchbar>
    <div class="custom-table">
      <div class="row header">
        <div class="col" style="display: flex; align-items: center">
          {{ "common.date" | translate }} @if(this.state.isBigScreen){
          <ion-icon
            size="small"
            style="color: black; cursor: default"
            name="caret-down-outline"
          ></ion-icon>
          }
        </div>
        <div class="col grow">{{ "common.constructionSite" | translate }}</div>
        <div class="col">
          @if(this.state.isBigScreen){ {{ "common.typeStatus" | translate }} }
        </div>
      </div>

      @for (csr of conDayReports; track csr.id) {
      <div class="row" (click)="openConstructionDayReportDetailModal(csr.id)">
        <div class="col">
          {{ toolService.formatDt(csr.date, this.state.isBigScreen) }}
        </div>
        <div class="col grow">
          {{ state.getConstructionSiteName(csr.constructionSite) }}
        </div>
        <div class="col">
          @if(csr.type === ConstructionDayReportType.$0){
          <ion-icon size="small" name="clipboard-outline"></ion-icon>
          } @if(csr.type === ConstructionDayReportType.$1){
          <ion-icon size="small" name="speedometer-outline"></ion-icon>
          } @if(csr.type === ConstructionDayReportType.$2){
          <ion-icon size="small" name="time-outline"></ion-icon>
          } @if(csr.isDraft && csr.approvedBy == null){
          <ion-icon size="small" name="document-text-outline"></ion-icon>
          } @if (csr.approvedBy != null) {
          <ion-icon
            style="color: rgb(0, 179, 0)"
            size="small"
            name="checkmark-circle-outline"
          ></ion-icon>
          } @if (csr.approvedBy == null && !csr.isDraft) {
          <ion-icon
            style="color: rgb(255, 174, 0)"
            name="checkmark-circle-outline"
          ></ion-icon>
          } @if (csr.errors?.length > 0) {
          <ion-icon
            style="color: rgb(228, 0, 0)"
            size="small"
            name="close-circle-outline"
          ></ion-icon>
          } @if(state.reportHasAttachments(csr.id) | async){
          <ion-icon size="small" name="attach-outline"></ion-icon>
          }
        </div>
      </div>
      }
    </div>
  </div>
  <lib-table-legend [items]="[0, 1, 2, 3, 8, 9, 10, 13]"></lib-table-legend>
</div>
